import {CanActivateFn, Router, UrlTree} from '@angular/router';
import {UserService} from "../../services/user.service";
import {inject} from "@angular/core";

export const loginGuard: CanActivateFn = (): boolean | UrlTree => {
  const userService = inject(UserService);
  const router = inject(Router);

  if (userService.isAuthenticated()) {
    return router.createUrlTree(['/dashboard'])
  }
  return true
};
